/** @internalapi @module path */ /** */
export * from './pathNode';
export * from './pathUtils';
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/@uirouter/core/lib-esm/path/index.js